import { render, staticRenderFns } from "./RoomTabs.vue?vue&type=template&id=f4f44a04&scoped=true"
import script from "./RoomTabs.vue?vue&type=script&lang=js"
export * from "./RoomTabs.vue?vue&type=script&lang=js"
import style0 from "./RoomTabs.vue?vue&type=style&index=0&id=f4f44a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f44a04",
  null
  
)

export default component.exports